import * as React from 'react';
import { BaseNavLink } from '../../base';
import { AppSidebarMessageCount } from '../app-sidebar.styles';
import * as S from './sidebar-nav.styles';

export interface ISidebarNavLinkProps {
    /** The sidebar is collapsed to its icon rail: the label moves into a tooltip. */
    rail: boolean;
    to: string;
    icon: string;
    label: string;
    /** Highlight beyond the link's own route match (e.g. every `patient-collections/*` tab). */
    active?: boolean;
    /** A count badge (open tasks); 0 hides it. */
    count?: number;
    end?: boolean;
}

/** One item of an app's sidebar. The app decides which items exist; this decides how one looks. */
export const SidebarNavLink: React.FunctionComponent<ISidebarNavLinkProps> = props => {
    const { rail, to, icon, label, active, count = 0, end } = props;
    const name = count > 0 ? `${label} (${count})` : label;

    const link = (
        // The tooltip is hover-only; in the rail the link needs its own name once the text is gone.
        <BaseNavLink to={to} end={end} aria-label={rail ? name : undefined}>
            {(linkProps): React.ReactElement => (
                <S.NavItem active={linkProps.active || active} rail={rail}>
                    <S.NavIcon path={icon} />
                    {!rail && <S.NavLabel>{label}</S.NavLabel>}
                    {!rail && count > 0 && <AppSidebarMessageCount>{count}</AppSidebarMessageCount>}
                </S.NavItem>
            )}
        </BaseNavLink>
    );

    return rail ? (
        <S.RailTooltip direction="right" variant="dark" title={<span>{name}</span>}>
            {link}
        </S.RailTooltip>
    ) : (
        link
    );
};
